/**
 * 分组堆叠柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const groupedStackedBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'group', type: 'string', required: false },
    { field: 'group2', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'grouped-stacked-bar-has-valid-grouping',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        // 验证数据整体是否有足够的分组信息
        const groupValues = data
          .map(item => String(item[encoding?.group as string] || ''))
          .filter(v => v !== undefined && v !== null && v !== '');
        const group2Values = data
          .map(item => String(item[encoding?.group2 as string] || ''))
          .filter(v => v !== undefined && v !== null && v !== '');

        return groupValues.length > 0 && group2Values.length > 0;
      },
      message: 'Grouped stacked bar must have data for both grouping dimensions',
      suggestion: 'Provide data with both group and group2 values across all rows',
      severity: 'error'
    },
    {
      name: 'grouped-stacked-bar-row-has-grouping',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        // 检查每一行至少有一个有效的分组字段
        return data.every(item => {
          const hasGroup =
            item[encoding?.group as string] !== undefined &&
            item[encoding?.group as string] !== null &&
            item[encoding?.group as string] !== '';
          const hasGroup2 =
            item[encoding?.group2 as string] !== undefined &&
            item[encoding?.group2 as string] !== null &&
            item[encoding?.group2 as string] !== '';
          return hasGroup || hasGroup2;
        });
      },
      message: 'Each data row must have at least one valid grouping field',
      suggestion: 'Ensure each data row contains either group or group2 field with non-empty value',
      severity: 'error'
    },
    {
      name: 'grouped-stacked-bar-sufficient-groups',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const groupValues = new Set(
          data
            .map(item => String(item[encoding?.group as string] || ''))
            .filter(v => v !== undefined && v !== null && v !== '')
        );
        const group2Values = new Set(
          data
            .map(item => String(item[encoding?.group2 as string] || ''))
            .filter(v => v !== undefined && v !== null && v !== '')
        );
        return groupValues.size >= 1 && group2Values.size >= 1;
      },
      message: 'Grouped stacked bar works best with multiple values in both group fields',
      suggestion:
        'Provide at least 2 different values for both group and group2 fields for better visualization',
      severity: 'warning'
    }
  ]
};
